module.exports = __webpack_public_path__ + "assets/img/init_pos_floor2.7c254dda.png";